import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import Spa08 from 'dc/Spa08';
import Spa16 from 'dc/Spa16';
import ChaMeta08 from 'dc/ChaMeta08';
import dayjs from 'dayjs';
import {
  Wrapper,
  Stats,
  TitleWrapper,
  Title,
  WrapperStdSideBtm,
  Tagline,
} from './elements';
import { useFormatDate } from 'common/hooks';
import { DATE_FORMAT } from 'resources/constants';

const deps = {
  challenge: state.challenge.campaign.challenge,
  campaign: state.challenge.campaign,
};

function BasicInfo({
  challenge,
  campaign,
}: typeof deps & ConnectedProps): React.ReactElement {
  const startDate = dayjs(challenge?.startDatetime);
  const endDate = dayjs(challenge?.endDatetime);
  const today = dayjs(Date.now()).startOf('day').valueOf();
  const daysFromStart = dayjs(today).diff(startDate, 'days');
  const totalDays = dayjs(endDate).diff(startDate, 'days');
  const percentFromStart = (daysFromStart * 100) / totalDays;
  const formatDate = useFormatDate();

  return (
    <Wrapper>
      <Stats />
      <Spa16 />
      <TitleWrapper>
        <Title as={'h1'}>{campaign?.name ?? '-'}</Title>
      </TitleWrapper>
      <WrapperStdSideBtm>
        <Tagline>{campaign?.tagline ?? '-'}</Tagline>
      </WrapperStdSideBtm>
      <WrapperStdSideBtm>
        <ChaMeta08
          fromDate={formatDate(
            challenge?.startDatetime,
            DATE_FORMAT.DAY_MONTH_TIME_SHORT
          )}
          toDate={formatDate(
            challenge?.endDatetime,
            DATE_FORMAT.DAY_MONTH_TIME_SHORT
          )}
          theme={'light'}
          percent={percentFromStart}
        />
      </WrapperStdSideBtm>
      <Spa08 />
    </Wrapper>
  );
}

export default connect(deps, BasicInfo);
